/** @fileoverview Barrel for StudentTasks skeleton components (plan Parte 6). */

export { StudentTaskCardSkeleton } from './StudentTaskCardSkeleton'
export { StudentTasksListSkeleton } from './StudentTasksListSkeleton'
export { DeliverableDrawerSkeleton } from './DeliverableDrawerSkeleton'
export { AssessmentDrawerSkeleton } from './AssessmentDrawerSkeleton'
